import { render, staticRenderFns } from "./CollectionUnitEdit.vue?vue&type=template&id=6f16f029"
import script from "./CollectionUnitEdit.vue?vue&type=script&lang=js"
export * from "./CollectionUnitEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnitEdit.vue?vue&type=style&index=0&id=6f16f029&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
